import { render, staticRenderFns } from "./channel_banner.vue?vue&type=template&id=72ff8f01&scoped=true"
import script from "./channel_banner.vue?vue&type=script&lang=js"
export * from "./channel_banner.vue?vue&type=script&lang=js"
import style0 from "./channel_banner.vue?vue&type=style&index=0&id=72ff8f01&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff8f01",
  null
  
)

export default component.exports